import React from 'react';

const Badge = ({ count, color = '#FA1', style }) => (
  <span
    style={{
      alignItems: 'center',
      borderRadius: 10,
      backgroundColor: color,
      color: '#fff',
      display: 'flex',
      fontSize: 12,
      justifyContent: 'center',
      minWidth: 20,
      minHeight: 20,
      padding: '0 5px',
      ...style,
    }}
  >
    {count}
  </span>
);

export default Badge;
